import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

export default class extends Controller {
  connect() {
    this.handleHidden = this.handleHidden.bind(this);
    this.element.addEventListener("hidden.bs.modal", this.handleHidden);
    Modal.getOrCreateInstance(this.element).show();
  }

  disconnect() {
    this.element.removeEventListener("hidden.bs.modal", this.handleHidden);

    const instance = Modal.getInstance(this.element);
    if (instance) instance.dispose();

    const frame = document.getElementById("turbo_modal");
    if (frame && !frame.querySelector(".modal")) frame.removeAttribute("src");

    if (document.querySelector(".modal.show")) return;

    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("padding-right");
  }

  close(event) {
    if (event && event.detail && event.detail.success === false) return;

    Modal.getOrCreateInstance(this.element).hide();
  }

  handleHidden() {
    const instance = Modal.getInstance(this.element);
    if (instance) instance.dispose();

    const frame = document.getElementById("turbo_modal");
    if (!frame) return;

    frame.removeAttribute("src");
    frame.innerHTML = "";
  }
}
